import { Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'brightside-web-home-feed-section',
    templateUrl: './home-feed-section.component.html',
    styleUrls: ['./home-feed-section.component.scss'],
    standalone: false
})
export class HomeFeedSectionComponent {
  @Input('sectionTitle') sectionTitle: string;
  @Input('routerLocation') routerLocation: string;
  @Input() showLoading = false;

  @ViewChild('contentWrapper') contentWrapper!: ElementRef;
  hasContent = false;

  private _router: Router = inject(Router);

  ngAfterViewInit() {
    // this.hasContent = this.contentWrapper.nativeElement.childNodes.length > 0;
  }

  clicked() {
    if (this.routerLocation) {
      this._router.navigate([this.routerLocation]);
    }
  }
}
